import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ProblemSolution from "./components/ProblemSolution";
import ProductOverview from "./components/ProductOverview";
import HowItWorks from "./components/HowItWorks";
import UseCases from "./components/UseCases";
import SocialProof from "./components/SocialProof";
import About from "./components/About";
import Security from "./components/Security";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import LoginPage from "./components/LoginPage";
import PatientAppFlow from "./components/PatientAppFlow";

export default function App() {
  const currentPath = typeof window !== "undefined" ? window.location.pathname.replace(/\/$/, "") : "";

  if (currentPath === "/login") {
    return <LoginPage />;
  }

  if (currentPath === "/patient-flow") {
    return <PatientAppFlow />;
  }

  return (
    <div className="font-sans antialiased text-slate-900">
      <Navbar />
      <Hero />
      <ProblemSolution />
      <ProductOverview />
      <HowItWorks />
      <Security />
      <UseCases />
      <SocialProof />
      <About />
      <CTA />
      <Footer />
    </div>
  );
}
